<template>
  <div id="monitoringbox-id" :class="[{
    'alertBackgroundCustom': this.colorUsed == 0,
    'normalBackgroundCustom': this.colorUsed == 1,
    'alertBackground': this.colorUsed == 2,
    'normalBackground': this.colorUsed == 3,
    'neutralBackground': this.colorUsed == 4,
    monitoringBoxP: layout2.gridMonitoringConfiguration.cardType == 'PGDI' ? true : false,
    monitoringBoxG: layout2.gridMonitoringConfiguration.cardType == 'PGDI' ? false : true,

    'occurrence-alert': item.occurrences > 0
  }]">
    <div :title="item.indicatorName" class="row1">{{ item.indicatorName }}
      <div v-if="item.occurrences > 0" class="count-occurrence-1">
        <div class="count-occurrence-2" @click="openModal(item)">
          <div v-if="item.occurrences < 99" :title="item.occurrences + ' - Ocorrências não tratadas'"
            class="count-occurrence-text">{{ item.occurrences }}</div>

          <div v-if="item.occurrences > 99" :title="item.occurrences + ' - Ocorrências não tratadas'"
            class="count-occurrence-text-1">+99</div>
        </div>
      </div>
      <div v-if="item.rtas > 0" class="count-rta-1" :class="{ 'has-rta-not-fcas': item.occurrences == 0 }"
        @click.stop="openPageRTA(item)">
        <div class="count-rta-2" :title="`${item.rtas} - RTAs não tratadas`">
          <div v-if="item.rtas < 99" class="count-rta-text">
            {{ item.rtas }}
          </div>
          <div v-else class="count-rta-text-1">+99</div>
        </div>
      </div>
      <div v-if="rtoActive && item.rtoInfluenced" class="rto-trend-1" :style="{ right: rtoBadgeRight }"
        title="Indicador influenciado pela otimização do RTO">
        <div class="rto-trend-2">
          <svg class="rto-trend-icon" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="2,12 5.5,8 8,10 14,3" />
            <polyline points="10,3 14,3 14,7" />
          </svg>
        </div>
      </div>
    </div>

    <div class="row2">
      <div class="row2Col3">{{ ParseNumber(item.lowerLimit) }}</div>
      <div class="row2Col2">{{ ParseNumber(item.onlineValue) }}</div>
      <div class="row2Col1">{{ ParseNumber(item.upperLimit) }}</div>
    </div>

    <div class="row3" v-if="layout2.gridMonitoringConfiguration.cardType == 'PGDI'">
      <div class="row3Col3">{{ ParseNumber(item.workshiftAIndicatorReability) }}</div>
      <div class="row3Col2">{{ ParseNumber(item.workshiftBIndicatorReability) }}</div>
      <div class="row3Col1">{{ ParseNumber(item.workshiftCIndicatorReability) }}</div>
      <div class="row3Txt">%</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { FiltersMixin } from "../mixins/filtersMixin";

export default {
  name: "MonitoringLayoutCard",
  props: ["item", "layout2", "sendSignalOpenModal"],
  data() { return { signal: 0, isSaoManoel: false, colorUsed: 0 } },
  mixins: [FiltersMixin],
  computed: {
    ...mapState(["rtoActive"]),
    rtoBadgeRight() {
      // Empilha à esquerda dos badges de ocorrência/RTA, quando presentes.
      let right = 1;
      if (this.item.rtas > 0) right += 30;
      if (this.item.occurrences > 0) right += 30;
      return `${right}px`;
    },
  },
  methods: {
    openModal(item) {
      this.$emit('sendSignalOpenModal', { item: item, signal: this.signal++ });
    },
    openPageRTA(indicator) {
      this.$router.push({ name: 'rtalist', params: { indicatorId: indicator.id } });
    },
  },

  created() {
    if (this.isSaoManoel)
      this.colorUsed = this.item.alert ? 0 : 1
    else
      this.colorUsed = this.item.alert ? 2 : 3

    this.colorUsed = (this.item.lowerLimit != "-" || this.item.upperLimit != "-") ? this.colorUsed : 4

    let unitName = localStorage.unitName;

    if (unitName != null && unitName != undefined && unitName == "São Manoel") this.isSaoManoel = true

    if (this.isSaoManoel)
      this.colorUsed = this.item.alert ? 0 : 1
    else
      this.colorUsed = this.item.alert ? 2 : 3

    this.colorUsed = (this.item.lowerLimit != "-" || this.item.upperLimit != "-") ? this.colorUsed : 4

  },
};
</script>

<style scoped>
.alertBackground,
.normalBackground,
.neutralBackground {
  border-radius: 3.5px;
  box-shadow: -2px 0 3px rgba(0, 0, 0, 0.705);
}

.occurrence-alert {
  box-shadow: 0 0 3px #FF891B;
  /* border: 1.5px solid #FF891B; */

}

.alertBackground {
  margin-right: 2px;
  display: grid;
  font-size: 1.3em;
  background-color: #d11e1d;
  color: rgb(255, 255, 255);
}

.normalBackground {
  margin-right: 2px;
  display: grid;
  font-size: 1.3em;
  background-color: rgb(0, 0, 0);
  color: rgb(255, 255, 255);
}

.alertBackgroundCustom {
  margin-right: 2px;
  display: grid;
  font-size: 1.3em;
  background-color: #A52A2A;
  color: rgb(255, 255, 255);
}

.normalBackgroundCustom {
  margin-right: 2px;
  display: grid;
  font-size: 1.3em;
  background-color: #0E635B;
  color: rgb(255, 255, 255);
}

.neutralBackground {
  margin-right: 2px;
  display: grid;
  font-size: 1.3em;
  background-color: #666666 !important;
  color: rgb(255, 255, 255);
}

.row1 {
  font-size: 0.6em;
  color: white;
  margin-left: 5px;
  /* letter-spacing: 0.8px; */
  /* text-transform: uppercase; */
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.row2 {
  display: grid;
  grid-template-columns: auto auto auto;
  text-align: center;
  align-items: center;
}

.row3 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  font-size: 0.6em;
  font-weight: 400;
  text-align: center;
}

.rto-trend-1 {
  position: absolute;
  background-color: white;
  border-radius: 20%;
  width: 28px;
  height: 28px;
  top: -5px;
}

.rto-trend-2 {
  position: absolute;
  background-color: #334155;
  border-radius: 20%;
  width: 24px;
  height: 24px;
  top: 2px;
  right: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rto-trend-icon {
  color: white;
  width: 14px;
  height: 14px;
}

.row2Col1,
.row2Col3 {
  font-size: 0.6em;
  text-align: center;
  font-weight: 500;
}

.row2Col2 {
  letter-spacing: 0.8px;
  color: white;
}

.row1,
.row2Col2 {
  font-weight: 500;
}

.infoTXT {
  color: black;
}

.monitoringBoxG {
  display: grid;
  grid-auto-flow: row;
  grid-template-rows: auto 1fr;
  height: 100%;
}

.monitoringBoxP {
  display: grid;
  grid-auto-flow: row;
  grid-template-rows: auto 1fr auto;
}

.count-occurrence-1 {
  position: absolute;
  background-color: white;
  border-radius: 50%;
  width: 29px;
  height: 29px;
  right: -3px;
  top: -5px;
  cursor: pointer;
}

.count-occurrence-2 {
  position: absolute;
  background-color: #FF891B;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  right: 3px;
  top: 3px;
}

.count-occurrence-text {
  padding: 2px 0 0 0;
  color: black;
  font-weight: bolder;
  text-align: center;

}

.count-occurrence-text-1 {
  padding: 2px 3px 0 0;
  color: black;
  font-weight: bolder;
  text-align: center;
}

.count-rta-1 {
  position: absolute;
  background-color: white;
  border-radius: 20%;
  width: 28px;
  height: 28px;
  right: 29px;
  top: -5px;
  cursor: pointer;
}

.count-rta-2 {
  position: absolute;
  background-color: #009a9b;
  border-radius: 20%;
  width: 24px;
  height: 24px;
  top: 2px;
  right: 2px;
}

.count-rta-text {
  padding: 2px 0 0 0;
  color: white;
  padding-right: 1px;
  font-weight: bolder;
  text-align: center;
}

.has-rta-not-fcas {
  right: 1px !important;
}

.count-rta-text-1 {
  padding: 2px 3px 0 0;
  padding-right: 1px;
  color: white;
  font-weight: bolder;
  text-align: center;
}

.waitTxt {
  display: flex;
  justify-content: center;
  /* font-weight: bold; */
  background: black;
  color: white;
  margin-bottom: 10px;
}

#btLock {
  position: absolute;
  top: 16px;
  left: 16px;
  background-color: transparent;
  border: none;
  z-index: 10;
  background: #fff;
  opacity: 0;
}

.img-slot,
.in-line {
  display: flex;
  align-items: center;
  justify-items: center;
}


#btLock:hover {
  opacity: 1;
  transition-duration: 500ms;
}

.lockIcon {
  color: black;
}

@media only screen and (max-width: 1220px) {
  #btLock {
    display: none;
  }
}

@media only screen and (max-width: 800px) {

  .row3Col1,
  .row3Col2,
  .row3Col3,
  .row3Txt {
    font-weight: 400;
  }

  .row2Col1,
  .row2Col3 {
    font-weight: 400;
  }
}
</style>
